export class Product {
    id: number;
    name: any;
    price: any;
    active: any;
    cost: any;
    pricePort: any;
    priceReceivable: any;
    stockQuantity: any;
    productMaster: any;
    cean: any;
	  ncm: any;
	  cest: any;
	  cfop: any;
	  ceanTrib: any;
	  cbenef: any;
	  unidadeComercial: any;
	  unidadeTributaria: any;
	  vinculoAdicional: any;
	  pglp: any;
	  pgNn: any;
	  pgNi: any;
	  valorPart: any;
    

    constructor(id: number, name: any, price: any, active: any, cost: any, pricePort: any,priceReceivable: any,
        stockQuantity: any,productMaster: any, cean: any, ncm: any, cest: any, cfop: any, ceanTrib: any,
        cbenef: any, unidadeComercial: any, unidadeTributaria: any, vinculoAdicional: any, pglp: any,
        pgNn: any,  pgNi: any, valorPart: any) {
        this.id = id;
        this.name = name;
        this.price = price;
        this.active = active;
        this.cost = cost;
        this.pricePort = pricePort;
        this.priceReceivable = priceReceivable;
        this.stockQuantity = stockQuantity;
        this.productMaster = productMaster;
        this.cean = cean;
        this.ncm = ncm;
        this.cest = cest;
        this.cfop = cfop;
        this.ceanTrib = ceanTrib;
        this.cbenef = cbenef;
        this.unidadeComercial = unidadeComercial;
        this.unidadeTributaria = unidadeTributaria;
        this.vinculoAdicional = vinculoAdicional;
        this.pglp = pglp;
        this.pgNn = pgNn;
        this.pgNi = pgNi;
        this.valorPart = valorPart;
    }
}